async function signOutUser() {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/auth/sign-out`;

  const response = await fetch(url, { credentials: "include" });
  const result = await response.json();

  return result;
}

export default signOutUser;
